<template>
    <div class="modal fade" :id="idModal" data-keyboard="false" data-backdrop="static" v-show="showModalFlag">
        <loading id="crudLoading" :active="displaySubmit" class="text-center" color="#000000" loader="spinner"></loading>
        <div class="modal-dialog" :class="dialogClass">
            <div class="modal-content">
                <!-- Header -->
                <div class="modal-header" v-if="!isCustomsHeader">
                    <h4 class="modal-title text-success">{{ headerTitle }}</h4>
                    <button type="button" class="close" aria-label="Close" @click="closeModal">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-header" v-else>
                    <slot name="header"></slot>
                </div>
                <div class="modal-body modal-body-customs">
                    <slot></slot>
                </div>

                <!-- Footer -->
                <div class="modal-footer justify-content-between" v-if="!isCustomsFooter">
                    <button type="button" class="btn btn-outline-dark pull-left" @click="closeModal">&nbsp;Đóng</button>
                    <button v-if="!displaySubmit" type="button" class="pull-right" :class="styleButton" @click="onSubmit">&nbsp;{{ titleSubmit }}</button>
                </div>
                <div class="modal-footer justify-content-between" v-else>
                    <slot name="footer"></slot>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { ref, toRefs, watch, computed } from "vue";
import Loading from "vue3-loading-overlay";
import $ from 'jquery';

export default {
    name: "TheCRUDFrameModal",
    components: {
        loading: Loading,
    },
    props: {
        idModal: String,
        dialogClass: String,
        headerTitle: String,
        displaySubmit: {
            type: Boolean,
            default: false
        },
        onSubmit: Function,
        titleSubmit: String,
        styleButton: String,

        isCustomsHeader: {
            type: Boolean,
            default: false
        },
        isCustomsFooter: {
            type: Boolean,
            default: false
        },
        showModalFlag: {
            type: Boolean,
            default: false,
        },
    },
    methods: {
        showModal() {
            this.$emit('update:showModalFlag', true);
            $('#' + this.idModal).modal('show');
        },
        closeModal() {
            this.$emit('update:showModalFlag', false);
            $('#' + this.idModal).modal('hide');
        }
    },
    watch: {
        displaySubmit(newVal) {
        },
        styleButton(newVal) {
        },
        showModalFlag(newVal) {
            if (newVal) {
                this.showModal();
            } else {
                this.closeModal();
            }
        },
    },
    mounted() {
        // Ensure modal is hidden when the component is mounted
        $('#' + this.idModal).modal('hide');
    },
};
</script>

<style>
    .modal-body-customs {
        max-height: 80vh; 
        overflow-y: auto;
    }
</style>
